import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from '../CFormItem';

import { MasterDataCombobox } from './MasterDataCombobox';

type Props = CFormItemProps & {
  value?: string;
  displayValue?: string;
  onChange: (value: string | null, name?: string) => void;
  allowEmpty?: boolean;
};

export const CFormJobGradeItem = buildCFormItem((props: Props) => {
  return (
    <CFormItemBase
      {...props}
      readComponent={props.displayValue || undefined}
      writeComponent={
        <MasterDataCombobox
          value={props.value}
          displayValue={props.displayValue}
          onChange={props.onChange}
          apiPath="/v2/job-grades"
          queryKeyPrefix="jobGrades"
          disabled={props.readonly}
        />
      }
    />
  );
});
